import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

const hotComics = comics.slice(0, 4);

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-16 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 font-display text-lg">
                漫
              </span>
              <span className="font-display text-xl tracking-wide">
                <span className="text-primary-600">5177</span>
                <span className="text-foreground-950">漫画网</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              5177漫画网致力于为漫画爱好者提供免费、精彩的韩国漫画在线阅读服务，全集中文翻译，更新及时，让每位读者都能随时随地沉浸在自己的漫画世界。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-600">
              <i className="ri-shield-check-line text-primary-500 text-base" aria-hidden="true" />
              全站资源免费 · 无需注册
            </div>
          </div>

          <nav aria-label="快速导航">
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#quick-links" className="hover:text-primary-600 transition-colors">
                快速导航
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li>
                <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="hover:text-primary-600 transition-colors">漫画大全</Link>
              </li>
              <li>
                <Link to="/comic/tent-secret" className="hover:text-primary-600 transition-colors">帐篷里的秘密</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-600 transition-colors">关于我们</Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="漫画分类">
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#categories" className="hover:text-primary-600 transition-colors">
                漫画分类
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm text-foreground-700">
              {categories
                .filter((c) => c.slug !== 'all')
                .map((c) => (
                  <li key={c.slug}>
                    <Link to={`/category/${c.slug}`} className="hover:text-primary-600 transition-colors">
                      {c.name}漫画
                    </Link>
                  </li>
                ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#hot-comics" className="hover:text-primary-600 transition-colors">
                热门漫画
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              {hotComics.map((c) => (
                <li key={c.id}>
                  <Link to={`/comic/${c.id}`} className="hover:text-primary-600 transition-colors">
                    《{c.title}》
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-600">
          <p>© 2024-2026 5177漫画网 www.5177comic.com 版权所有 · 本网站漫画仅供学习交流使用</p>
          <div className="flex items-center gap-4">
            <a
              href="mailto:service@5177comic.com"
              rel="nofollow"
              className="inline-flex items-center gap-1.5 hover:text-primary-600 transition-colors"
            >
              <i className="ri-mail-line text-sm" aria-hidden="true" />
              service@5177comic.com
            </a>
            <a
              href="#top"
              rel="nofollow"
              className="inline-flex items-center gap-1.5 hover:text-primary-600 transition-colors"
            >
              <i className="ri-arrow-up-line text-sm" aria-hidden="true" />
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}